// for get all users
export const LOGOUT = "logout";
export const LOGOUT_SUCCESS = "logout_success";
export const LOGOUT_FAILURE = "logout_failure";
